import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-report-year',
  templateUrl: './select-report-year.component.html',
  styleUrls: ['./select-report-year.component.scss']
})
export class SelectReportYearComponent implements OnInit, OnDestroy {

  @Input() yearsAmount: number = 2022
  public years: any[] = [];
  public selectedYear: number | null = null;
  private yearSub$!: Subscription;

  constructor(
      private sharedService: SharedService
    ) {
      this.yearSub$ = this.sharedService.sharedYearReport.subscribe((year: number) => {
        this.selectedYear = year;
      });
    }

  ngOnInit(): void {
    this.generateYears(this.yearsAmount);
    this.selectedYear = new Date().getFullYear(); // ← Establece el año actual por defecto
    this.sharedService.nextYearReport = this.selectedYear; // ← Opcional: propaga el valor inicial
  }
  ngOnDestroy(): void {
    if (this.yearSub$) this.yearSub$.unsubscribe();
  }

  generateYears(startYear: number) {
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= startYear; year--) {
      this.years.push({ name: year.toString(), value: year });
    }
  }

  onYearChange(event: number) {
    this.sharedService.nextYearReport = event;
  }
}
